// components
import { cn } from '@/utils/cn';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '../Button';
import Text from '../Text';
import Icon from '../Icon';
import LoadingSpinnerV2 from '../Skeleton/LoadingSpinnerV2';
import ButtonLabel from '../Typography/ButtonLabel';

// utils

function OrderCancelationSuccess({ data, onView, onClose, isCOD = true }) {
  const [openModal, setOpenModal] = useState(onView);
  const { isLoading } = useSelector((state) => state.orders);

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        setOpenModal(true);
      }, 100);
    } else {
      setOpenModal(false);
    }
  }, [onView]);

  const handleClose = (closeState, productAddState) => {
    setOpenModal(closeState);
    setTimeout(() => {
      onClose(closeState, productAddState);
    }, 200);
  };

  return (
    <div
      className={cn(
        'w-full h-full bg-black/70 flex items-center justify-center opacity-0 -z-10 transition-all duration-300 fixed inset-0',
        {
          '!opacity-100 !z-[501]': openModal,
        },
      )}
    >
      <div className="w-full max-w-[480px] mx-8 px-16 lg:px-24 py-10 lg:py-24 relative rounded-[4px] lg:rounded-[12px] transition-all duration-[400ms]">
        <div className="mb-12">
          <Icon
            type="close"
            color="#fff"
            onClick={() => handleClose(false, 'goToCancelation')}
            className="cursor-pointer ml-auto"
          />
        </div>
        <div className="bg-white p-24 rounded-xl shadow-product-slider-shadow">
          {isLoading ? (
            <LoadingSpinnerV2 />
          ) : (
            <>
              {isCOD ? (
                <>
                  <Icon
                    type="checkmark-rounded-bg"
                    color="#00685F"
                    className="size-[32px] lg:size-[40px] mb-[10px] mx-auto"
                  />
                  <Text
                    type="sub_title"
                    className="text-center text-18 lg:text-20 text-fire-chalk font-semibold leading-28 tracking-[0.36px] lg:tracking-[0.4px] mb-16"
                  >
                    Successfully Order Cancelled!
                  </Text>
                  <Text
                    type="paragraph"
                    className="text-coarse-wool text-center text-14 lg:text-16 font-medium leading-20 tracking-[0.28px] lg:tracking-[0.32px] mb-24 px-10"
                  >
                    Your order has been cancelled successfully.
                  </Text>
                </>
              ) : (
                <>
                  <Icon
                    type="checkmark-rounded-bg"
                    color="#00685F"
                    className="size-[32px] lg:size-[40px] mb-[10px] mx-auto"
                  />
                  <Text
                    type="sub_title"
                    className="text-center text-18 lg:text-20 text-fire-chalk font-semibold leading-28 tracking-[0.36px] lg:tracking-[0.4px]"
                  >
                    Successfully Submitted
                  </Text>
                  <Text
                    type="sub_title"
                    className="text-center text-18 lg:text-20 text-fire-chalk font-semibold leading-28 tracking-[0.36px] lg:tracking-[0.4px] mb-[10px]"
                  >
                    Order Cancellation Request!
                  </Text>
                  <Text
                    type="paragraph"
                    className="text-coarse-wool text-center text-14 lg:text-16 font-medium leading-20 tracking-[0.28px] lg:tracking-[0.32px] mb-24 px-10"
                  >
                    Your cancellation request has been successfully submitted.
                    Our team will review it, and you’ll be notified of the
                    status soon.
                  </Text>
                </>
              )}

              <div className="flex flex-col w-full gap-4">
                <Button
                  type="primary"
                  className="w-full max-w-[200px] lg:max-w-[296px] mx-auto line-clamp-1 bg-tealgreen !h-[40px] !py-0 hover:bg-cape-verde"
                  onClick={() => handleClose(false, 'cancelationDetail')}
                >
                  <ButtonLabel
                    label="Cancellation Details"
                    className=" text-sm lg:text-base text-white text-center font-bold"
                  />
                </Button>

                <Button
                  type="outline"
                  className="w-full max-w-[200px] lg:max-w-[296px] !border-tealgreen mx-auto line-clamp-1 !h-[40px] !py-0"
                  onClick={() => handleClose(false, 'goHome')}
                >
                  <Text
                    type="span"
                    className="!text-tealgreen text-center text-14 lg:text-16 font-bold leading-20 tracking-[0.28px] lg:tracking-[0.32px]"
                  >
                    Go to Home
                  </Text>
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default OrderCancelationSuccess;
